// extracted by mini-css-extract-plugin
export default {"actions":"q6pjH","star":"zDnHB","starFilled":"_5QvXQ","insideModal":"KdvlK","wired":"N+2lv"};